import { useMemo } from 'react';
import axios from 'axios';
import { useAuth } from "../contexts/AuthContext";
import {API_ENDPOINT} from "../constants/apiConstants";

const useAxiosWithAuth = () => {
    const { auth } = useAuth();

    const axiosInstance = useMemo(() => {
        const instance = axios.create({
            baseURL: API_ENDPOINT,
        });

        instance.interceptors.request.use((config) => {
            config.headers.Authorization = auth.token;
            return config;
        }, (error) => {
            return Promise.reject(error);
        });

        return instance;
    }, [auth.token]);

    return axiosInstance;
};

export default useAxiosWithAuth;
